import React from "react";

import { epocToDate, formatTime12hr, getNextScheduleMonthly } from "utils";

function nextSchedule(props) {
  let content = "Next backup is scheduled at: ";
  let time = "";
  let currentTime = Math.round(new Date().getTime() / 1000);

  let nextDay = Math.round(new Date().setHours(23, 59, 59, 999) / 1000);
  let sameDay = Math.round(new Date().setHours(0, 0, 0, 0) / 1000);

  let display = true;
  const currentType =
    props.scheduleInfo.type && props.scheduleInfo.type.current != null
      ? props.scheduleInfo.type.current
      : props.scheduleInfo.type;

  let timeObj12hr = formatTime12hr(
    props.scheduleInfo.startTime &&
      props.scheduleInfo.startTime.value !== undefined
      ? props.scheduleInfo.startTime.value
      : props.scheduleInfo.startTime
  );
  let time12hrStr =
    timeObj12hr.hrs + ":" + timeObj12hr.min + " " + timeObj12hr.meridian;

  switch (props.enums.ScheduleType.props[currentType].key) {
    case "INTERVAL":
      if (props.scheduleInfo.scheduleChanged || props.isBackupPlan) {
        let futureDate = new Date(
          (currentTime + props.scheduleInfo.interval.selected) * 1000
        );
        let intTime = {
          hrs: String(futureDate.getHours() % 12 || 12).padStart(2, "0"),
          min: String(futureDate.getMinutes()).padStart(2, "0"),
          meridian: futureDate.getHours() >= 12 ? "PM" : "AM"
        };
        let intTime12hr =
          intTime.hrs + ":" + intTime.min + " " + intTime.meridian;
        time =
          epocToDate(
            currentTime + props.scheduleInfo.interval.selected,
            "MMM d, yyyy"
          ) +
          ", " +
          intTime12hr;
      } else {
        const nextBackupTime =
          props.clients[props.clientDetails.clientUUID].nextBackupTime;
        let nextBackupDate = new Date(nextBackupTime * 1000);
        let intTime = {
          hrs: String(nextBackupDate.getHours() % 12 || 12).padStart(2, "0"),
          min: String(nextBackupDate.getMinutes()).padStart(2, "0"),
          meridian: nextBackupDate.getHours() >= 12 ? "PM" : "AM"
        };
        let intTime12hr =
          intTime.hrs + ":" + intTime.min + " " + intTime.meridian;
        if (nextBackupTime < currentTime) {
          display = false;
        } else {
          time = epocToDate(nextBackupTime, "MMM d, yyyy") + ", " + intTime12hr;
        }
      }
      break;
    case "DAILY":
      if (
        currentTime >
        sameDay +
          (props.scheduleInfo.startTime &&
          props.scheduleInfo.startTime.value !== undefined
            ? props.scheduleInfo.startTime.value
            : props.scheduleInfo.startTime)
      ) {
        time =
          epocToDate(
            nextDay +
              (props.scheduleInfo.startTime &&
              props.scheduleInfo.startTime.value !== undefined
                ? props.scheduleInfo.startTime.value
                : props.scheduleInfo.startTime),
            "MMM d, yyyy"
          ) +
          ", " +
          time12hrStr;
      } else {
        time =
          epocToDate(
            sameDay +
              (props.scheduleInfo.startTime &&
              props.scheduleInfo.startTime.value !== undefined
                ? props.scheduleInfo.startTime.value
                : props.scheduleInfo.startTime),
            "MMM d, yyyy"
          ) +
          ", " +
          time12hrStr;
      }

      break;
    case "CUSTOM":
      let FinalDays = 8;
      let minDays;
      props.scheduleInfo.weekDays.forEach(v => {
        minDays = (7 + (v - new Date().getDay())) % 7;
        if (minDays < FinalDays) {
          if (minDays === 0) {
            if (
              currentTime >
              sameDay +
                (props.scheduleInfo.startTime &&
                props.scheduleInfo.startTime.value !== undefined
                  ? props.scheduleInfo.startTime.value
                  : props.scheduleInfo.startTime)
            ) {
              FinalDays = 7;
            } else {
              FinalDays = minDays;
            }
          } else {
            FinalDays = minDays;
          }
        }
      });

      if (FinalDays !== 8) {
        time =
          epocToDate(
            sameDay +
              FinalDays * 60 * 60 * 24 +
              (props.scheduleInfo.startTime &&
              props.scheduleInfo.startTime.value !== undefined
                ? props.scheduleInfo.startTime.value
                : props.scheduleInfo.startTime),
            "MMM d, yyyy"
          ) +
          ", " +
          time12hrStr;
      }
      break;
    case "NO_SCHEDULE":
      content = "No Backup is scheduled";
      break;
    case "MONTHLY":
      const nextSchTime = getNextScheduleMonthly(
        props.scheduleInfo.months,
        props.scheduleInfo.monthDays,
        props.scheduleInfo.startTime.value ?? props.scheduleInfo.startTime
      );
      time = nextSchTime
        ? new Date(nextSchTime * 1000).toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
          })
        : "No Backup is scheduled";
    default:
      break;
  }

  return (
    <React.Fragment>
      {display ? (
        <div className="next_schedule_msg">
          <p>
            {content}
            <strong>{time}</strong>
          </p>
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
}

export default nextSchedule;
